"use strict";

var e = require("../video-6a7acca4.js");
require("react"), require("prop-types"), require("../taggedTemplateLiteral-97b463ad.js"), require("../_commonjsHelpers-f10b257f.js"), require("styled-components"), module.exports = e.VideoComponent;